
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import Input from '../../components/formComponents/input';
import VideoPlayer from '../../components/common/video';

/*Assets*/
import Deals from '../../assets/images/deals.png';

/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';

class AdType extends Component {
  constructor(props){
    super(props);
    this.state = {
      tabIndex: 1,
      data: this.props.data ? this.props.data : {},
      schedules: this.props.data ? this.props.data.schedules : [],
      errorMessage: ""
    }
  }

  componentDidMount() {

  }

  tabItemClick(tempItem){
    this.setState({tabIndex: tempItem});
  }
  selectChange = async (category) => {
    await this.setState({category: category});
  }


  async createAd(){
    this.setState({createAdLoading: true});
    var url = devconfig.vendor+ 'ads/booking';
    var adData = this.props.data;
    var data = JSON.stringify({
      schedules: adData.date,
      booking_date: adData.schedules[0].date,
      ads_location_id: adData.adLocation.id,
      banner_type: adData.bannerStyle.id,
      banner_style: adData.bannerStyle,
      content: adData.filesArray,
      files_array: adData.filesArray,
      day_wise: adData.adLocation.validity_type==4 ? false: true,
      selected_slots: adData.schedules[0].selectedSlotIds,
      category_id: this.props.data.adLocation.type==1 ? this.props.data.category : undefined,
      sub_category_id:  this.props.data.sub_category?  this.props.data.sub_category: undefined,
    });
    if(this.props.local){
      var data = JSON.stringify({
        schedules: adData.date,
        booking_date: adData.schedules[0].date,
        ads_location_id: adData.adLocation.id,
        banner_type: adData.bannerStyle.id,
        banner_style: adData.bannerStyle,
        content: adData.filesArray,
        files_array: adData.filesArray,
        day_wise: adData.adLocation.validity_type==4 ? false: true,
        selected_slots: adData.schedules[0].selectedSlotIds,
        department_id: this.props.data.adLocation.type==1 ? this.props.data.category : undefined,
        category_id:  this.props.data.sub_category?  this.props.data.sub_category: undefined,
      });
    }
    await APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        window.location = "/scheduled-ads"
      }else{
        this.setState({errorMessage: response.message, createAdLoading: false})
      }
    }.bind(this))
  }

  render() {

     const filterBy = [
      { value: 1, label: 'Active' },
      { value: 2, label: 'Ongoing' },
      { value: 3, label: 'Completed' },
    ]

    console.log("Addd review");
    console.log(this.state.data);

    return (
      <div className="e-main-content e-vendor-table">
        <h2 className="e-page-head">Create Ad's</h2>

            <div>
              <div className="row">
                <div className="col-lg-11">
                  <div className="e-vendor-category-list e-edit-ad">
                    <div className="row">
                      <div className="col-lg-12">
                        <h6 className="e-ad-type">Ad Type</h6>
                        <h6 className="e-ad-type e-category">{this.state.data ? this.state.data.adLocation.ads_location : "N/A"}</h6>
                      </div>
                    </div>
                    <h6 className="e-ad-type pt-3 pb-3">Content</h6>
                    <div className="row">
                    {
                      this.state.data?
                        this.state.data.filesArray && this.state.data.filesArray.map((file, index)=>{
                          if(file.fileURL){
                            return(
                              <div className="col-lg-4 mb-3">
                                <div className="e-ad-dotted-border e-deals-border e-schedule-ad-preview">
                                  {
                                    file.fileURL.indexOf(".mp4") > -1 ?
                                      <VideoPlayer url={file.fileURL} />
                                    :
                                      <img src={file.fileURL} className="e-deals pb-4" alt="Offer Logo"/>
                                  }
                                  
                                  <span className="e-ad-website-link">
                                    {
                                      file.website ?
                                        <a href={file.website} target="_blank">{file.website}</a>
                                      :
                                        <p className="text-danger mb-0">No website link added</p>
                                    }
                                  </span>
                                </div>
                              </div>
                            )
                          }
                          
                        })
                      :
                        null
                    }
                    </div>
                    <div className="row pt-4 ml-1">
                    {
                      this.state.schedules.length?
                        <div className="col-lg-12 pl-0 mb-2">
                          <h6 className="e-ad-type mb-2">Selected schedules: </h6>
                          {
                            this.state.schedules.map((schedule, index)=>{
                              if(this.props.data.adLocation.validity_type!=4){
                                return(
                                  <div className="mb-3">
                                    <p><b>{schedule.date}</b></p>
                                  </div>
                                )
                              }
                              return(
                                <div className="mb-3">
                                  <p><b>{schedule.date}: </b></p>
                                  <div>
                                    {
                                      schedule.selectedSlots.map((item2, index)=>{
                                        return(
                                          <span className="e-adList-slot">{item2.slot}</span>
                                        );
                                       })
                                    }
                                  </div>
                                </div>
                              )
                            })
                          }
                        </div>
                      : null
                    }
                    </div>
                    {
                      this.state.errorMessage.length ?
                        <div className="row pt-4 pb-4">
                          <div className='col-lg-12'>
                            <p className="text-danger e-error">{this.state.errorMessage}</p>
                          </div>
                        </div>
                      :
                        null
                    }
                    <div className="row ml-1">
                    {
                      this.state.createAdLoading?
                        <div className="text-right col-lg-12">
                          <span className="e-lazy-loader"></span>
                        </div>
                      :
                        <div className="text-right col-lg-12">
                          <button className="e-s-btn" type="submit" value="Submit" onClick={this.createAd.bind(this)}>Create Ad</button>
                        </div>
                    }
                    </div>
                  </div>
                </div>
              </div>

            </div>

      </div>

    );
  }
}

export default AdType;
